import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import {NavMenu} from "../../components/GetNavMenu";
import {Tabs, Space, Title, Box} from "@mantine/core";
import {Footer} from "../../components/GetFooter";
import React, {useEffect, useState} from "react";
import {useStyles} from "../../models/styles/NotFoundStyle";
import {IconShieldLock} from "@tabler/icons-react";
import {AdminUsersAccessCodes} from "../../components/admin/users/AdminUsersAccessCodes";

export function UsersAdmin({memory}: SystemMemoryProps) {
    const { classes } = useStyles();

    // Users admin states
    const [usersAdminPage, setUsersAdminPage] = useState(<></>)

    function UsersAdminNavigation(id: number) {
        switch (id) {
            case 1:
                setUsersAdminPage(<AdminUsersAccessCodes memory={memory} />);
                return
            default:
                setUsersAdminPage(<AdminUsersAccessCodes memory={memory} />);
                return
        }
    }

    // Load default page
    useEffect(() => { UsersAdminNavigation(0) }, []);

    return (
        <>
            <NavMenu memory={memory}></NavMenu>
            <Space h="lg" />
            <Title order={1} className={classes.title}>Manage Accounts</Title>
            <Tabs color="indigo" defaultValue="users" p={'lg'}>
                <Tabs.List grow position="center">
                    <Tabs.Tab value="users" icon={<IconShieldLock size="0.9rem" />} onClick={() => {UsersAdminNavigation(1)}}>Access Codes</Tabs.Tab>
                </Tabs.List>

            </Tabs>

            <Box p={'md'}>{usersAdminPage}</Box>

            <Footer data={[]}></Footer>
        </>
    );
}